import { useTranslation } from "react-i18next";
import { Sms, Call } from "iconsax-react";
import type { ContactsSection as ContactsSectionType } from "../../types/personalSheet";
import ProfileDataRow from "../ProfileDataRow";

interface Props {
  contacts: ContactsSectionType | null;
}

export default function ContactsSection({ contacts }: Props) {
  const { t } = useTranslation("EmployeePortal");

  if (!contacts) {
    return <p className="text-body-regular-md content-base-secondary">{t("personalSheet.empty.contacts")}</p>;
  }

  return (
    <div className="flex flex-col">
      <ProfileDataRow icon={Sms} label={t("personalSheet.fields.email")} value={contacts.email} />
      <ProfileDataRow icon={Call} label={t("personalSheet.fields.phone")} value={contacts.phone} />
      <ProfileDataRow icon={Call} label={t("personalSheet.fields.phoneAdditional")} value={contacts.phone_additional} />
    </div>
  );
}
